import { Search } from "lucide-react";
import { Input, SearchField } from "lumir-back-office-ui";
import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";
import { useNavigate, useSearchParams } from "react-router-dom";
import { route } from "../../../../../router/route";
import { useEffect, useState, useCallback } from "react";

// const LoadingSpinner = () => (
//   <div className="animate-spin rounded-full h-12 w-12 border-4 border-palette-lumir-600  border-t-transparent" />
// );

const SkeletonLoader = ({ count = 8, isMobile }) => {
  return Array(count)
    .fill(0)
    .map((_, index) => (
      <div
        key={`skeleton-${index}`}
        className="flex flex-col py-5 animate-pulse"
      >
        <div className="flex flex-col gap-4">
          {/* Title skeleton - larger and bolder */}
          <div
            className={`h-7 w-4/5 bg-gray-200 rounded-md ${
              isMobile ? "mt-2" : "mt-3"
            }`}
          ></div>
          {/* Status/department skeleton - "상시채용 | 경력" */}
          <div className="flex items-center gap-2">
            <div className="h-4 w-16 bg-gray-200 rounded-md"></div>
            <div className="h-4 w-1 bg-gray-300"></div>
            <div className="h-4 w-12 bg-gray-200 rounded-md"></div>
          </div>
        </div>
        {index !== count - 1 && (
          <div className="bg-semantic-secondary-stroke-normal-default h-[1px] w-full my-8" />
        )}
      </div>
    ));
};

const RecruitList = ({ recruitList, isMobile, lastItemRef }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState(
    searchParams.get("keyword") || ""
  );
  const [isSearch, setIsSearch] = useState(false);

  const updateSearchParams = useCallback(
    (value) => {
      if (!value || value === "null" || value.trim() === "") {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete("keyword");
        setSearchParams(newParams);
        setSearchValue("");
      } else {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("keyword", value);
        setSearchParams(newParams);
      }
    },
    [setSearchParams, searchParams]
  );

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      updateSearchParams(e.target.value);
    }
  };

  useEffect(() => {
    setIsSearch(true);
    const debounceTimer = setTimeout(() => {
      setIsSearch(false);
      const currentKeyword = searchParams.get("keyword");
      if (
        (!currentKeyword && searchValue) ||
        (currentKeyword && currentKeyword !== searchValue)
      ) {
        updateSearchParams(searchValue);
      }
    }, 1000);

    return () => clearTimeout(debounceTimer);
  }, [searchValue, updateSearchParams, searchParams]);

  return (
    <section className="w-full space-y-20">
      <SearchField variant="default" className="h-[40px]">
        <Input
          onKeyDown={handleSearch}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          placeholder="검색"
          className="h-[40px]"
          variant="outline"
          size="lg"
          leftIcon={<Search className="h-8" />}
        />
      </SearchField>
      <section className="w-full relative">
        {isSearch ? (
          <SkeletonLoader count={8} isMobile={isMobile} />
        ) : (
          recruitList.map((item, index) => (
            <div
              key={item.id}
              className="flex flex-col"
              ref={index === recruitList.length - 1 ? lastItemRef : null}
            >
              <TextDisplay
                size={isMobile ? "md" : "lg"}
                className="[&_.label]:text-semantic-error-global-global-default [&_.label]:cursor-none custom-cursor"
                textData={{
                  label: item.dDate,
                  primary: item.title,
                  description: item.description,
                }}
                onClick={() => {
                  navigate(`${route.jobAnnounceDetail}/${item.id}`);
                }}
              />
              {index !== recruitList.length - 1 && (
                <div className="bg-semantic-secondary-stroke-normal-default h-[1px] w-full my-16" />
              )}
            </div>
          ))
        )}
      </section>
    </section>
  );
};

export { RecruitList, SkeletonLoader };
